var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPfp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 46,
    viewBox: "0 0 44 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 46,
    rx: 22,
    fill: "#E2209E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9984 21.2516C18.1661 20.4193 17.75 19.4187 17.75 18.25C17.75 17.0812 18.1661 16.0807 18.9984 15.2484C19.8307 14.4161 20.8312 14 22 14C23.1687 14 24.1693 14.4161 25.0016 15.2484C25.8339 16.0807 26.25 17.0812 26.25 18.25C26.25 19.4187 25.8339 20.4193 25.0016 21.2516C24.1693 22.0839 23.1687 22.5 22 22.5C20.8312 22.5 19.8307 22.0839 18.9984 21.2516ZM13.5 28.875V28.025C13.5 27.4229 13.6551 26.8697 13.9654 26.3654C14.2756 25.861 14.6872 25.4757 15.2 25.2094C16.2979 24.6604 17.4135 24.2489 18.5469 23.9747C19.6802 23.7006 20.8312 23.5632 22 23.5625C23.1687 23.5618 24.3198 23.6992 25.4531 23.9747C26.5865 24.2503 27.7021 24.6618 28.8 25.2094C29.3135 25.475 29.7254 25.8603 30.0357 26.3654C30.3459 26.8704 30.5007 27.4236 30.5 28.025V28.875C30.5 29.4594 30.2921 29.9598 29.8763 30.3763C29.4605 30.7928 28.9601 31.0007 28.375 31H15.625C15.0406 31 14.5405 30.7921 14.1247 30.3763C13.709 29.9605 13.5007 29.4601 13.5 28.875Z",
    fill: "#1E1A1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPfp);
export default __webpack_public_path__ + "static/media/pfp.34c899411deb7e89b8b96719f69c4876.svg";
export { ForwardRef as ReactComponent };